function getV1InputFormatType() {
  return {
    CREATE_TRIP: 1,
    CANCEL_TRIP: 2,
    GET_TRIPS: 3,
    GET_A_TRIP: 4,
    END_TRIP: 5,
    MID_WAY_UPDATE_TRIP: 6,
    GET_SHIPPER_TRIP: 7,
    CANCEL_SHIPPER_TRIP: 8,
    GET_TRIP_STATS: 9,
    TRIGGER_CONSENT: 10,
    GET_TRACK_COUNT: 11,
    GET_TRIP_ERROR: 12,
    TRIP_STATUS_REPORT: 13,
    GET_ACTIVE_TRIPS: 14,
  };
}

function getTrackingType() {
  return {
    SIM: 'SIM', GPS: 'GPS', APP: 'APP', HYPERTRACK: 'HYPERTRACK',
  };
}

// TODO: avoid this kind of constants try to use function returning constant object. for example getTrackingType()
const pingLocationErrorCodes = {
  LOCATION_NOT_AVAILABLE: 'LOCATION NOT AVAILABLE',
  CONSENT_NOT_ALLOWED: 'CONSENT NOT ALLOWED',
  PHONE_SWITCHED_OFF: 'PHONE SWITCHED OFF',
  OUT_OF_COVERAGE: 'OUT OF COVERAGE',
};

function getEndTripReason() {
  return {
    DESTINATION_REACHED: 1,
    AUTO_COMPLETE: 2,
    ANOTHER_TRIP: 3,
    INDENT_DELIVERED: 4,
    MANUALLY_ENDED: 5,
  };
}

const getAuthenticationType = () => ({
  TOKEN_AS_QUERY_PARAM: 'TOKEN_AS_QUERY_PARAM', // G-Trac, iAlert GPS providers
  LOGIN_AND_BEARER_TOKEN: 'LOGIN_AND_BEARER_TOKEN', // Rivigo GPS providers
  NO_AUTH: 'NO_AUTH',
  NOT_REQUIRED: 'NOT_REQUIRED',
});

const getContentTypeOfVariable = () => ({
  APPLICATION_X_WWW_FORM_URLENCODED: 'application/x-www-form-urlencoded',
  APPLICATION_JSON: 'application/json', // post/put payload
  BASIC_TOKEN: 'BASIC_TOKEN', // need to go as { Authorization: `basic ${accessToken}` };
  BEARER_TOKEN: 'BEARER_TOKEN', // need to go as { Authorization: `bearer ${accessToken}` };
  PATH_VARIABLE: 'PATH_VARIABLE', // will be replaced at path variable.
  QUERY_PARAM: 'QUERY_PARAM', // will be passed as query param
});

const getStringManipulationTypes = () => ({
  TO_LOWER_CASE: 'TO_LOWER_CASE',
  TO_UPPER_CASE: 'TO_UPPER_CASE',
});

const getDateManipulationTypes = () => ({
  EPOCH_TO_UTC: 'EPOCH_TO_UTC',
});

const getSupportedResponseFormats = () => ({
  XML: 'XML',
  JSON: 'JSON',
});

const getAttachmentType = () => ({
  TRIP_STATUS_REPORT: 'TRIP_STATUS_REPORT',
});

const TrackingNotificationTypes = {
  EMAIL: 'email',
  SMS: 'sms',
};

const TrackingNotificationEvents = {
  ETA_UPDATE: 'eta_update',
  CREATE_TRIP: 'trip_creation',
};

const TripCreationEvents = {
  TRUCK_IN: 'TRUCK_IN',
  TRUCK_OUT: 'TRUCK_OUT',
  AUTO_SIM_TRACKING: 'AUTO_SIM_TRACKING',
};

const EndTripAt = {
  ENTRY: 'entry',
  EXIT: 'exit',
};

module.exports = {
  getV1InputFormatType,
  getTrackingType,
  pingLocationErrorCodes,
  getEndTripReason,
  getAuthenticationType,
  getAttachmentType,
  TrackingNotificationEvents,
  TrackingNotificationTypes,
  EndTripAt,
  getContentTypeOfVariable,
  getStringManipulationTypes,
  getDateManipulationTypes,
  getSupportedResponseFormats,
  TripCreationEvents,
};
